import classNames from 'classnames';
import React from 'react';

import { Icon, IconTypes } from '@eika/icon';

import type { ChipProps } from './types';

const ToggleChip: React.FC<ChipProps> = ({
    className,
    children,
    active = false,
    showXOnActive = true,
    setActive,
    onClick,
    ...rest
}) => {
    return (
        <button
            {...rest}
            type="button"
            aria-pressed={active}
            className={classNames(
                'sgw-chip',
                className,
                {
                    'sgw-chip__active': active,
                    'sgw-chip__with-cross-button': showXOnActive,
                },
                `sgw-chip__toggle`,
            )}
            onClick={(e) => {
                onClick?.(e);
                setActive?.(!active);
            }}
        >
            {children}
            {showXOnActive && active && (
                <span className="sgw-chip__icon-wrapper">
                    <Icon className="sgw-chip__icon" type={IconTypes.KRYSS_24} />
                </span>
            )}
        </button>
    );
};

export default ToggleChip;
